import { RadioGroup, RadioGroupProps } from "@chakra-ui/react";
import { FC } from "react";

export type Props = RadioGroupProps;

export const Radio: FC<Props> = (props) => {
    return <RadioGroup {...props}>{props.children}</RadioGroup>;
};
